import React from "react";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";

interface EmptyTableMessageProps {
  children?: React.ReactNode;
  className?: string;
}

export const EmptyTableMessage = ({
  children,
  className,
}: EmptyTableMessageProps) => (
  <Empty className={emptyStateVariants({ layout: "collection", className })}>
    {typeof children === "string" || Array.isArray(children) ? (
      <EmptyHeader>
        <EmptyDescription>{children}</EmptyDescription>
      </EmptyHeader>
    ) : (
      children
    )}
  </Empty>
);
